import React from 'react';
import { Link } from '@mui/material';
import footerStyle from '../footerStyle';

const FooterLink = ({ href, onClick, children }) => {
  const classes = footerStyle();
  return (
    <Link href={href} onClick={onClick} className={classes.link}>
      {children}
    </Link>
  );
};

export default FooterLink;